module.exports = __webpack_public_path__ + "static/img/6.00955fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/6.jpg
// module id = vhxb
// module chunks = 0